import {connect} from "react-redux";
import FastServices from "./FastServices";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {savePage} from "../../../globalState/object/actions";


let mapStateToProps = (state) => {
    return {
        services: state.object?.services,
        objectId: state.object.id,
		needleServices: state.object?.stepByStepServices
    }
};

export default compose(connect(mapStateToProps, {savePage}), withRouter)(FastServices);




